// src/main.ts
// Issue #29：改為 vite-ssg 的 createApp 出入口。
// WHY：SSG 需在 Node 預渲染每頁實體 HTML（SEO），client 端再掛載 hydrate。
//      ViteSSG 在 SSG 時用 memory history、執行時用 web history，路由改由它提供。
import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import { routes } from './router'
import { createPinia } from 'pinia'
import scrollReveal from '@/directives/scrollReveal'

// 全域樣式
import '@/assets/styles/main.scss'

// 建立應用程式實例（vite-ssg 規定必須 export createApp）
export const createApp = ViteSSG(
    App,
    { routes },
    ({ app }) => {
        // 使用 Pinia 狀態管理
        const pinia = createPinia()
        app.use(pinia)

        // 全域 directive（SSR 中僅註冊，掛載階段才動 DOM，無炸 risk）
        app.directive('scroll-reveal', scrollReveal)
    }
)